import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports) => {
			$scope.moment = moment;
			$scope.status = STATUSES.UNLOADED;

			$scope.dataTable = DataTablesService.configure({
				id:                 $scope.reportId,
				title:              'Evaluations - Evaluations Due Next Month',
			}, {
				order:             [
					[
						3,
						'asc',
					],
					[
						1,
						'asc',
					],
					[
						0,
						'asc',
					],
				],
			});

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get()
				              .then((data) => {
					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/EF83CD30-6A69-434F-9971-077EE03F38F6/index.js